import { render, staticRenderFns } from "./PosterMake.vue?vue&type=template&id=05685713&scoped=true&"
import script from "./PosterMake.vue?vue&type=script&lang=js&"
export * from "./PosterMake.vue?vue&type=script&lang=js&"
import style0 from "./PosterMake.vue?vue&type=style&index=0&id=05685713&scoped=true&lang=less&"
import style1 from "./PosterMake.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05685713",
  null
  
)

export default component.exports